<template>
  <div class="footer">
    <div class="content">
      <div class="contact">{{ getI18nMessage(longContactUs ? 'longContactUs' : 'contactUs') }}</div>
      <div class="app-link">
        <div style="flex-direction: row;">
          <img
            v-for="(appLink, index) in appLinks"
            :key="index"
            :src="require(`@/assets/icons/${appLink.img}.svg`)"
            style="cursor: pointer; margin: 0 8px;"
            @click="onClickAppLink(appLink)"
          />
        </div>
      </div>
      <div class="term-container" :style="{ flexDirection: isMobile ? 'column' : 'row' }">
        <div
          class="term"
          :style="{ marginBottom: isMobile ? '2vh' : '0', marginRight: isMobile ? '0' : '8px' }"
          @click="onClickTermButton"
        >
          {{ getI18nMessage('termsOfUse') }}
        </div>
        <div class="copyright">© 2020 ViaBus</div>
      </div>
    </div>
  </div>
</template>

<script>
const i18n = {
  contactUs: {
    th: 'ติดต่อเรา',
    en: 'Contact us',
  },
  longContactUs: {
    th: 'หากต้องการความช่วยเหลือ ติดต่อเราได้ที่',
    en: 'If you still need help, contact us via:',
  },
  termsOfUse: {
    th: 'ข้อกำหนดและความเป็นส่วนตัว',
    en: 'Terms of Use & Privacy Policy',
  },
};

import { get } from 'lodash';
import { isMobile } from '@/utils/useragent';

export default {
  components: {},
  props: {
    language: {
      type: String,
      default: 'en',
    },
    longContactUs: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isMobile,
    appLinks() {
      return [
        {
          img: 'ic-facebook',
          link: 'https://www.facebook.com/viabusapp',
        },
        {
          img: 'ic-twitter',
          link: 'https://www.twitter.com/viabusapp',
        },
        {
          img: 'ic-line',
          link: 'https://line.me/R/ti/p/%40viabusapp',
        },
        {
          img: 'ic-mail',
          link: 'mailto:contact@viabus.co',
        },
      ];
    },
  },
  data() {
    return {};
  },
  watch: {},
  methods: {
    getI18nMessage(key) {
      return get(i18n, `${key}.${this.language}`, '');
    },
    onClickAppLink(appLink) {
      window.open(appLink.link, '_blank');
    },
    onClickTermButton() {
      window.open('https://www.viabus.co/terms', '_blank');
    },
  },
  mounted() {},
};
</script>

<style scoped>
div {
  display: flex;
  flex-direction: column;
}

.footer {
  position: absolute;
  bottom: 0;
  margin-top: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content {
  margin-bottom: 20px;
  align-items: center;
}

.contact {
  font-size: 15px;
  font-weight: 500;
  color: #263373;
  margin-bottom: 2vh;
}

.app-link {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 5vh;
}

.term {
  font-size: 13px;
  font-weight: 500;
  color: #7a88b8;
  margin-bottom: 2vh;
  text-decoration: underline;
  cursor: pointer;
}

.copyright {
  font-size: 13px;
  font-weight: 500;
  color: #263373;
}

.term-container {
  align-items: center;
}
</style>
